<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Vouchers</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link> / <b>Loyalty Point System</b> / <b>Vouchers</b> /
      <router-link to="/lps/voucher/product">Products</router-link> /
      <b>View</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      <!-- Graph -->
      <div class="col-md-12 mb-4">
        <div class="card text-left">
          <div class="card-body">
            <div class="row">
              <!-- Graph -->
              <div class="col-9">
                <button class="btn btn-primary" @click="print">Print</button>
                <div id="printGraph">
                  <div id="monthly">
                    <h4 class="text-center">
                      <b
                        >Vouchers Redeemed for
                        {{ product.name }}
                        for Year
                        {{ year }}</b
                      >
                    </h4>

                    <GChart
                      type="ColumnChart"
                      :data="voucherData"
                      :options="voucherOptions"
                    />
                  </div>
                </div>
              </div>
              <!-- Graph -->

              <div
                class="col-3 d-flex flex-column flex-sm-row align-items-center"
              >
                <span class></span>
                <!-- Year -->
                <div class="col-6">
                  <div class="form-group">
                    <label>Filter by Year</label>
                    <select class="form-control" v-model="filter_year">
                      <option v-for="(year, index) in years" :key="index">{{
                        year
                      }}</option>
                    </select>
                  </div>

                  <div class="form-group">
                    <label>Filter by Discount</label>
                    <select class="form-control" v-model="filter_discount">
                      <option
                        v-for="(discount, index) in discounts"
                        :key="index"
                        >{{ discount.voucher_discount }}</option
                      >
                    </select>
                  </div>

                  <div class="form-group">
                    <button class="btn btn-primary" @click="applyFilter()">
                      Filter
                    </button>
                    &nbsp;
                    <button
                      id="btnAll"
                      class="btn btn-primary d-none"
                      @click="removeFilter()"
                    >
                      All
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Graph -->

      <!-- Redeemed Vouchers By Discount Report Table -->
      <div class="col-md-12 mb-4">
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">
              Redeemed Vouchers by Discount Report
            </h4>

            <!-- Discount filter -->
            <div class="row">
              <div class="col-6">
                <label><b>Date From</b></label>
                <input
                  type="date"
                  class="form-control"
                  v-model="discountDateFrom"
                />
              </div>
              <div class="col-6">
                <label><b>Date To</b></label>
                <input
                  type="date"
                  class="form-control"
                  v-model="discountDateTo"
                />
              </div>
            </div>

            <br />

            <div class="text-left">
              {{
                discountDateFromFormatted != null &&
                discountDateToFormatted != null
                  ? `Redeemed Vouchers by Discount Report from ${discountDateFromFormatted} to ${discountDateToFormatted}`
                  : ""
              }}
            </div>

            <div class="text-right">
              <button
                class="btn btn-rounded btn-primary mr-2"
                style="width: 150px;"
                @click="filterByDiscount()"
              >
                Filter
              </button>
              <button
                class="btn btn-rounded btn-primary"
                style="width: 150px;"
                @click="resetFilter(1)"
              >
                Reset
              </button>
            </div>
            <!-- Discount filter -->

            <div class="table-responsive">
              <table
                id="voucher_by_discount_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th width="5%">No.</th>
                    <th width="10%">Discount Amount</th>
                    <th width="10%">No. of Redeemed</th>
                    <th width="10%">No. of Used</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(voucher, index) in voucher_discounts"
                    :key="index"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>
                      {{
                        voucher.discount_type == "%"
                          ? voucher.total_price + voucher.discount_type
                          : voucher.discount_type + voucher.total_price
                      }}
                    </td>
                    <td>{{ voucher.total_redeemed }}</td>
                    <td>{{ voucher.total_used }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- Redeemed Vouchers By Discount Table -->

      <!-- Redeemed Vouchers Report Table -->
      <div class="col-md-12 mb-4">
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Redeemed Vouchers Report</h4>

            <!-- Discount filter -->
            <div class="row">
              <div class="col-6">
                <label><b>Date From</b></label>
                <input type="date" class="form-control" v-model="dateFrom" />
              </div>
              <div class="col-6">
                <label><b>Date To</b></label>
                <input type="date" class="form-control" v-model="dateTo" />
              </div>
            </div>

            <br />

            <div class="text-left">
              {{
                dateFromFormatted != null && dateToFormatted != null
                  ? `Redeemed Vouchers Report from ${dateFromFormatted} to ${dateToFormatted}`
                  : ""
              }}
            </div>

            <div class="text-right">
              <button
                class="btn btn-rounded btn-primary mr-2"
                style="width: 150px;"
                @click="filterReport()"
              >
                Filter
              </button>
              <button
                class="btn btn-rounded btn-primary"
                style="width: 150px;"
                @click="resetFilter(2)"
              >
                Reset
              </button>
            </div>
            <!-- Discount filter -->

            <div class="table-responsive">
              <table
                id="voucher_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th width="5%">No.</th>
                    <th>Code</th>
                    <th>Discount</th>
                    <th>Order ID</th>
                    <th>Redeemed By</th>
                    <th>Owned By</th>
                    <th>Used By</th>
                    <th>Redeemed At</th>
                    <th>Expired At</th>
                    <th>Used At</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(voucher, index) in vouchers" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ voucher.code }}</td>
                    <td>{{ voucher.voucher_discount }}</td>
                    <td>
                      {{
                        voucher.order_id == null || voucher.order_id == ""
                          ? "-"
                          : voucher.order_id
                      }}
                    </td>
                    <td>
                      <router-link :to="redirectUser(voucher.redeemed_by)">
                        {{ voucher.redeemed_by }}
                      </router-link>
                    </td>
                    <td>
                      <router-link :to="redirectUser(voucher.owned_by)">
                        {{ voucher.owned_by }}
                      </router-link>
                    </td>
                    <td>
                      <span v-if="voucher.used_by == null"> - </span>
                      <router-link v-else :to="redirectUser(voucher.used_by)">
                        {{ voucher.used_by }}
                      </router-link>
                    </td>
                    <td>{{ voucher.redeemed_at }}</td>
                    <td>
                      {{ voucher.expired_at }}
                    </td>
                    <td>
                      {{ voucher.used_at == null ? "-" : voucher.used_at }}
                    </td>
                    <td>
                      {{ voucher.status }}
                      <br>
                      <button
                        v-if="voucher.convertable"
                        @click="convert(voucher)"
                        class="btn btn-primary btn-rounded btn-block"
                      >
                        Convert to Discount Token
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- Redeemed Vouchers Report Table -->

      <!-- Converted Report Table -->
      <div class="col-md-12 mb-4">
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Conversion to Discount Token Logs</h4>

            <!-- Discount filter -->
            <div class="row">
              <div class="col-6">
                <label><b>Date From</b></label>
                <input type="date" class="form-control" v-model="convertedDateFrom" />
              </div>
              <div class="col-6">
                <label><b>Date To</b></label>
                <input type="date" class="form-control" v-model="convertedDateTo" />
              </div>
            </div>

            <br />

            <div class="text-left">
              {{
                convertedDateFromFormatted != null && convertedDateToFormatted != null
                  ? `Converted Discount Token Logs from ${convertedDateFromFormatted} to ${convertedDateToFormatted}`
                  : ""
              }}
            </div>

            <div class="text-right">
              <button
                class="btn btn-rounded btn-primary mr-2"
                style="width: 150px;"
                @click="filterConverted()"
              >
                Filter
              </button>
              <button
                class="btn btn-rounded btn-primary"
                style="width: 150px;"
                @click="resetFilter(2)"
              >
                Reset
              </button>
            </div>
            <!-- Discount filter -->

            <div class="table-responsive">
              <table
                id="converted_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th width="5%">No.</th>
                    <th>Code</th>
                    <th>Discount</th>
                    <th>Order ID</th>
                    <th>Redeemed By</th>
                    <th>Owned By</th>
                    <th>Redeemed At</th>
                    <th>Converted By</th>
                    <th>Converted At</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(voucher, index) in converts" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ voucher.code }}</td>
                    <td>{{ voucher.voucher_discount }}</td>
                    <td>
                      {{
                        voucher.order_id == null || voucher.order_id == ""
                          ? "-"
                          : voucher.order_id
                      }}
                    </td>
                    <td>
                      <router-link :to="redirectUser(voucher.redeemed_by)">
                        {{ voucher.redeemed_by }}
                      </router-link>
                    </td>
                    <td>
                      <router-link :to="redirectUser(voucher.owned_by)">
                        {{ voucher.owned_by }}
                      </router-link>
                    </td>
                    <td>{{ voucher.redeemed_at }}</td>
                    <td>
                      <span v-if="voucher.converted_by_id == null"> - </span>
                      <router-link v-else :to="redirectUser(voucher.converted_by_id)">
                        {{ voucher.converted_by }}
                      </router-link>
                    </td>
                    <td>
                      {{ voucher.converted_at }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- Converted Report Table -->
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import { GChart } from "vue-google-charts";
import moment from "moment";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "voucher-product-id",
  components: {
    GChart,
    Loading
  },

  data() {
    return {
      vouchers: [],
      discounts: [],
      voucher_discounts: [],
      converts: [],
      product: [],

      voucherData: [],
      voucherOptions: {
        height: 300,
        legend: "none",
        vAxis: {
          title: "No. Vouchers Redeemed",
          textStyle: {
            fontSize: 12,
            bold: true
          },
          titleTextStyle: {
            fontSize: 14,
            bold: true
          }
        },
        hAxis: {
          textStyle: {
            fontSize: 8,
            bold: true,
            color: "#848484"
          }
        }
      },

      year: 0,
      discount: 0,
      years: [],
      filter_year: "",
      filter_discount: "",

      isLoading: false,
      discountDateFrom: null,
      discountDateTo: null,
      discountDateFromFormatted: null,
      discountDateToFormatted: null,

      dateFrom: null,
      dateTo: null,
      dateFromFormatted: null,
      dateToFormatted: null,

      convertedDateFrom: null,
      convertedDateTo: null,
      convertedDateFromFormatted: null,
      convertedDateToFormatted: null,
    };
  },

  methods: {
    checkToken() {
      let token = localStorage.getItem("token");

      if (token === null || token === "") {
        return false;
      }

      token = JSON.parse(token);
      token = token.access_token;

      return token;
    },

    async loadVouchers() {
      let token = localStorage.getItem("token");
      let product_id = this.$route.params.id;

      // Reset filters
      this.dateFrom = null;
      this.dateFromFormatted = null;
      this.dateTo = null;
      this.dateToFormatted = null;

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        try {
          let result = await axios.get(
            axios.lpsURL + "/voucher/redeemed/" + product_id,
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          );
          this.product = result.data.product;
          this.vouchers = result.data.vouchers;
          this.voucherData = result.data.chart;
          this.discounts = result.data.discounts;

          console.log(this.vouchers)
        } catch (error) {
          console.log(error);
        }
      }
    },

    async loadFilterVouchers() {
      if (!this.checkToken()) {
        return;
      }

      let url = "";
      let product_id = this.$route.params.id;

      if (this.dateFrom == null && this.dateTo == null) {
        url = `/voucher/redeemed/` + product_id;
      } else {
        url = `/voucher/redeemed/${product_id}?date_from=${this.dateFrom}&date_to=${this.dateTo}`;
      }

      this.dateFromFormatted = moment(this.dateFrom).format("DD MMMM YYYY");
      this.dateToFormatted = moment(this.dateTo).format("DD MMMM YYYY");

      try {
        let result = await axios.get(axios.lpsURL + url, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
        });

        this.vouchers = result.data.vouchers;
        this.voucherData = result.data.chart;
        this.discounts = result.data.discounts;
      } catch (e) {
        console.log(e);
        return;
      }
    },

    async loadVoucherByDiscount() {
      let token = localStorage.getItem("token");
      let product_id = this.$route.params.id;

      // Reset filters
      this.discountDateFrom = null;
      this.discountDateFromFormatted = null;
      this.discountDateTo = null;
      this.discountDateToFormatted = null;

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        try {
          let result = await axios.get(
            axios.lpsURL + "/voucher/discount/" + product_id,
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          );
          this.voucher_discounts = result.data.vouchers;
        } catch (error) {
          console.log(error);
        }
      }
    },

    async loadConverted() {
      let token = localStorage.getItem("token");
      let product_id = this.$route.params.id;

      // Reset filters
      this.convertedDateFrom = null;
      this.convertedDateFromFormatted = null;
      this.convertedDateTo = null;
      this.convertedDateToFormatted = null;

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        try {
          let result = await axios.get(
            axios.lpsURL + "/voucher/convert/" + product_id + "/logs",
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          );
          this.converts = result.data.data;
        } catch (error) {
          console.log(error);
        }
      }
    },

    async loadFilterByDiscount() {
      if (!this.checkToken()) {
        return;
      }

      let url = "";
      let product_id = this.$route.params.id;

      if (this.discountDateFrom == null && this.discountDateTo == null) {
        url = `/voucher/discount/` + product_id;
      } else {
        url = `/voucher/discount/${product_id}?date_from=${this.discountDateFrom}&date_to=${this.discountDateTo}`;
      }

      this.discountDateFromFormatted = moment(this.discountDateFrom).format(
        "DD MMMM YYYY"
      );
      this.discountDateToFormatted = moment(this.discountDateTo).format(
        "DD MMMM YYYY"
      );

      try {
        let result = await axios.get(axios.lpsURL + url, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
        });

        this.voucher_discounts = result.data.vouchers;
      } catch (e) {
        console.log(e);
        return;
      }
    },

    async loadFilterConverted() {
      if (!this.checkToken()) {
        return;
      }

      let url = "";
      let product_id = this.$route.params.id;

      if (this.convertedDateFrom == null && this.convertedDateTo == null) {
        url = "/voucher/convert/" + product_id + "/logs";
      } else {
        url = `/voucher/convert/${product_id}/logs?converted_date_from=${this.convertedDateFrom}&converted_date_to=${this.convertedDateTo}`;
      }

      this.convertedDateFromFormatted = moment(this.convertedDateFrom).format("DD MMMM YYYY");
      this.convertedDateToFormatted = moment(this.convertedDateTo).format("DD MMMM YYYY");

      try {
        let result = await axios.get(axios.lpsURL + url, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
        });

        this.converts = result.data.data;
      } catch (e) {
        console.log(e);
        return;
      }
    },

    async filterByDiscount() {
      this.isLoading = true;
      this.destroyDatatable();
      await this.loadFilterByDiscount();
      this.createDatatable();
      this.isLoading = false;
    },

    async filterReport() {
      this.isLoading = true;
      this.destroyDatatable();
      await this.loadFilterVouchers();
      this.createDatatable();
      this.isLoading = false;
    },

    async filterConverted() {
      this.isLoading = true;
      this.destroyDatatable();
      await this.loadFilterConverted();
      this.createDatatable();
      this.isLoading = false;
    },

    async resetFilter(int) {
      this.destroyDatatable();
      switch (int) {
        case 1:
          await this.loadVoucherByDiscount();
          this.createDatatable();
          return;
        case 2:
          await this.loadVouchers();
          this.createDatatable();
          return;
        case 3:
          await this.loadConverted();
          this.createDatatable();
          return;
      }
    },

    createDatatable() {
      $("#voucher_tbl").DataTable({
        pageLength: 5,
        lengthMenu: [
          [5, 10, 25, 50, -1],
          ["5 rows", "10 rows", "25 rows", "50 rows", "Show all"]
        ],
        dom: "Bfrtip",
        buttons: ["csv", "pdf"]
      });

      $("#voucher_by_discount_tbl").DataTable({
        pageLength: 5,
        lengthMenu: [
          [5, 10, 25, 50, -1],
          ["5 rows", "10 rows", "25 rows", "50 rows", "Show all"]
        ],
        dom: "Bfrtip",
        buttons: ["csv", "pdf"]
      });

      $("#converted_tbl").DataTable({
        pageLength: 5,
        lengthMenu: [
          [5, 10, 25, 50, -1],
          ["5 rows", "10 rows", "25 rows", "50 rows", "Show all"]
        ],
        dom: "Bfrtip",
        buttons: ["csv", "pdf"]
      });
    },

    destroyDatatable() {
      $("#voucher_tbl")
        .DataTable()
        .destroy();

      $("#voucher_by_discount_tbl")
        .DataTable()
        .destroy();

      $("#converted_tbl")
        .DataTable()
        .destroy();
    },

    print() {
      // Pass the element id here
      this.$htmlToPaper("printGraph");
    },

    loadYearFilter() {
      let date = new Date();
      let start_date = 2020;
      let current_year = date.getFullYear();

      this.year = current_year;

      // Past 5 year
      for (let i = start_date; i < current_year + 1; i++) {
        this.years.push(i);
      }
    },

    applyFilter() {
      $("#btnAll").removeClass("d-none");
      let product_id = this.$route.params.id;

      // Declare filters
      let year = "";
      let discount = "";

      if (this.filter_year.length != 0) {
        year = "?filter_year=" + this.filter_year;
        this.year = this.filter_year;
      }

      if (this.filter_discount.length != 0) {
        discount =
          year != ""
            ? "&filter_discount=" + this.filter_discount
            : "?filter_discount=" + this.filter_discount;
        this.discount = this.filter_discount;
      }

      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(
            axios.lpsURL + "/voucher/redeemed/" + product_id + year + discount,
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(result => {
            this.vouchers = result.data.vouchers;
            this.voucherData = result.data.chart;
          });
      }
    },

    removeFilter() {
      $("#btnAll").addClass("d-none");

      this.filter_year = "";
      this.years = [];

      this.filter_discount = "";

      this.loadYearFilter();
      this.loadVouchers();
    },

    redirectUser(ic_number) {
      return "/customer/" + ic_number;
    },

    async convert(product) {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        
        try {
          let result = await axios.post(
            axios.lpsURL + "/voucher/convert/" + product.id + "/single",
            {},
            {
              headers: {
                Authorization: "Bearer " + token,
              },
            }
          );

          swal({
            icon: result.data.success ? "success" : "error",
            text: result.data.message,
          }).then(() => {
            window.location.reload()
          });

        } catch (error) {
          console.log(error);
        }
      }
    },
  },

  async created() {
    await this.loadVouchers();
    await this.loadVoucherByDiscount();
    await this.loadConverted();
    this.createDatatable();
    this.loadYearFilter();
  },

  mounted() {}
};
</script>
